import React from 'react';

export const PageHeroImage = ({ src, alt, testId }) => (
  <figure className="page-hero-image" data-testid={testId}>
    <img src={src} alt={alt} loading="eager" decoding="async" width="1402" height="1122" />
  </figure>
);

export default PageHeroImage;
